import axios from '@/api/axios'

const createFaq = faq => {
    return axios.post('/faqs', faq)
}

const getFaqs = () => {
    return axios.get('/faqs')
}

const getFaq = id => {
    return axios.get(`/faqs/${id}`)
}

const updateFaq = (id, faqInput) => {
    return axios.put(`/faqs/${id}`, faqInput)
}

const deleteFaq = id => {
    return axios.delete(`/faqs/${id}`)
}

export default {
    createFaq,
    getFaqs,
    getFaq,
    updateFaq,
    deleteFaq
}
